import { isEmpty } from "lodash";
import React, { useState, useContext, useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import styles from "../assets/newCss/sky.css";
import { Helmet } from "react-helmet";
import Aboutus from "../components/staticContent/Aboutus";
import GeneralTerms from "../components/staticContent/GeneralTerms";
import Kyc from "../components/staticContent/Kyc";
import PrivacyPolicy from "../components/staticContent/PrivacyPolicy";
import RulesRegulation from "../components/staticContent/RulesRegulation";
import ResponsibleGaming from "../components/staticContent/ResponsibleGaming";
import { ImEye, ImEyeBlocked } from "react-icons/im";
import Chat from "../components/Chat";
import eyeslash from "../assets/images/eye-slash.png";

function LoginMobile(props) {
  let {
    loginUser,
    loginError,
    user,
    open,
    setOpen,
    content,
    slug,
    setSlug,
    handleContentToggle,
    chatToogle,
    setChatToogle,
  } = useContext(AuthProvider);

  const navigate = useNavigate();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    unregister,
    reset: reset2,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });
  const [getValidateCode, setValidateCode] = useState("");
  const [data, setData] = useState({});
  const onSubmit2 = (data) => {
    //if (parseInt(data.validateCode) === parseInt(getValidateCode)) {
      loginUser(data);
    //}
  };
  const canvasRef = useRef(null);
  // const changeCode = () => {
  //   const canvas = canvasRef.current;
  //   const context = canvas.getContext("2d");
  //   context.font = "bold 120px sans-serif";
  //   const code = Math.floor(1000 + Math.random() * 9000);
  //   context.clearRect(0, 0, canvas.width, canvas.height);
  //   context.fillText(code, 0, 110);
  //   setValidateCode(code);
  // };
  // const changeCode = () => {
  //   const canvas = canvasRef.current;
  //   const context = canvas.getContext("2d");
  //   context.font = "italic bold 150px serif";
  //   const code = Math.floor(1000 + Math.random() * 9000);
  //   context.clearRect(0, 0, canvas.width, canvas.height);
  //   context.fillText(code, 0, 130, 300);
  //   setValidateCode(code);
  // };
  const getSetting = async (event) => {
    try {
      const { status, data: response_users } = await apiGet(apiPath.getSetting);
      if (status === 200) {
        if (response_users.success) {
          setData(response_users.results);
        }
      }
    } catch (err) {}
  };
  useEffect(() => {
    // changeCode();
    getSetting();
  }, []);
  useEffect(() => {
    if (user !== null) {
      navigate("/");
    }
  }, [user]);
  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const [displayPopUp, setDisplayPopUp] = useState(true);

  // when pop-up is closed this function triggers
  const closePopUp = () => {
    console.log("----------")
    // setting key "seenPopUp" with value true into localStorage
    localStorage.setItem("seenPopUp", true);
    // setting state to false to not display pop-up
    setDisplayPopUp(false);
  };

  // the useEffect to trigger on first render and check if in the localStorage we already have data about user seen and closed the pop-up
  useEffect(() => {
    // getting value of "seenPopUp" key from localStorage
    let returningUser = localStorage.getItem("seenPopUp");
    // if it's not there, for a new user, it will be null
    // if it's there it will be boolean true
    // setting the opposite to state, false for returning user, true for a new user
    setDisplayPopUp(!returningUser);
  }, []);

  return (
    <div className="newLogin">
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no"
        />
      </Helmet>

      <div className="login_main">
        <header className="login-head">
          {/* <Link to="/" className="close"></Link> */}
          <h1></h1>
          <div id="powerWrap" className="betfair-wrap">
            <p>Powered by</p>
            <span>
              <img
                src={
                  process.env.REACT_APP_IMAGE_URL +
                  "/assets/images/betfair_black.png"
                }
                alt=""
                draggable="false"
              />
            </span>
          </div>
        </header>
        <Form onSubmit={handleSubmit2(onSubmit2)}>
          <dl className="form-login">
            <Form.Group
              style={{ marginBottom: "10px" }}
              id="loginNameErrorClass"
            >
              <Form.Control
                type="text"
                autocomplete="off"
                // id="loginName"
                className={errors2.username ? "is-invalid" : ""}
                {...register2("username", {
                  required: "Please enter Username",
                })}
                placeholder="Username"
              />
              {errors2.username && errors2?.username?.message && (
                <label className="invalid-feedback text-left">
                  {errors2.username.message}
                </label>
              )}
            </Form.Group>
            <Form.Group className="mb-2">
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={passwordType ? passwordType : "password"}
                  placeholder="Password"
                  className={errors2.password ? "is-invalid" : ""}
                  {...register2("password", {
                    required: "Please enter password",
                  })}
                />
                <div
                          className="input-group-btn"
                          style={{
                            position: "absolute",
                            right: "0",
                            top: "0",
                            bottom: "0px",
                          }}
                        >
                          <span
                            className="btn btn-outline-primary"
                            onClick={togglePassword}
                            style={{
                              backgroundColor: "transparent",
                              backgroundImage: `none`,
                              border: "0",
                              padding: "11px 9px",
                             
                              fontSize: `6.5vw`,
                              lineHeight: `0`,
                            }}
                          >
                            {passwordType === "password" ? (
                              <img src={eyeslash} style={{ width: `20px` }} />
                            ) : (
                              <img src={eyeslash} style={{ width: `20px` }} />
                            )}
                          </span>
                        </div>
              </div>
              {errors2.password && errors2.password.message && (
                <label className="invalid-feedback text-left">
                  {errors2.password.message}
                </label>
              )}
            </Form.Group>
            {/* <dd id="validCodeErrorClass" style={{ display: "block" }}>
              <input
                type="number"
                keyboardType="numeric"
                autocomplete="off"
                maxLength="4"
                className={errors2.validateCode ? "is-invalid" : ""}
                {...register2("validateCode", {
                  required: "Please enter validate code",
                  validate: {
                    validate: (value) =>
                      parseInt(value) === parseInt(getValidateCode) ||
                      "Invalid validate code",
                  },
                })}
                onChange={(e) => {
                  if (e.target.value.length == 4) {
                    e.target.blur();
                    unregister("validateCode", { keepValue: true });
                  }
                }}
                id="validCode"
                placeholder="Validation Code"
                style={{ padding: `2.66667vw 1.86667vw` }}
              />

              <canvas
                ref={canvasRef}
                onClick={changeCode}
                className="inputcanvas"
                id="authenticateImage"
              />

              {errors2.validateCode && errors2.validateCode.message && (
                <label className="invalid-feedback text-left">
                  {errors2.validateCode.message}
                </label>
              )}
            </dd> */}

            <dd>
              <Button type="submit" className="btn-send w-100" id="loginBtn">
                Login
              </Button>
            </dd>
            {loginError?.status && (
              <dd id="errorMsg" class="state" style={{color:`#d0021b`}}>
               {loginError?.msg}
              </dd>
            )}
          </dl>
        </Form>

        <div class="support-wrap extend-support">
          <div class="extend-btn">
            <img
              src={
                process.env.REACT_APP_IMAGE_URL +
                "/assets/images/home/transparent.gif"
              }
              title="customer"
              class="support-customer"
            />

            <a href="javascript:void(0)" target="_blank" class="ui-link">
              Customer support1
            </a>

            <a
              href="#"
              target="_blank"
              class="split-line ui-link"
            >
              support2
            </a>
          </div>
          <div class="extend-btn">
            <img
              src={
                process.env.REACT_APP_IMAGE_URL +
                "/assets/images/home/transparent.gif"
              }
              title="WhatsApp"
              class="support-whatsapp"
            />

            <a href="javascript:void(0)" target="_blank" class="ui-link">
              WhatsApp 3
            </a>

            <a href="javascript:void(0)" target="_blank" class="split-line ui-link">
              WhatsApp 4
            </a>
          </div>
          <div class="extend-btn">
            <img
              src={
                process.env.REACT_APP_IMAGE_URL +
                "/assets/images/home/transparent.gif"
              }
              title="Telegram"
              class="support-telegram"
            />
            <a
              href="#"
              target="_blank"
              class="ui-link"
            >
              lc247support1
            </a>

            <a
              href="#"
              target="_blank"
              class="split-line ui-link"
            >
              lc247support1
            </a>
          </div>
          <div class="support-social">
            <div class="social-btn">
              <img
                src={
                  process.env.REACT_APP_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                title="Skype"
                class="support-skype"
              />
              <a
                href="#"
                target="_blank"
                class="ui-link"
              >
                Skype
              </a>
            </div>
            <div class="social-btn">
              <img
                src={
                  process.env.REACT_APP_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                title="Email"
                class="support-mail"
              />
              <a href="#" target="_blank" class="ui-link">
                Email
              </a>
            </div>
            <div class="social-btn">
              <img
                src={
                  process.env.REACT_APP_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                title="Instagram"
                class="support-ig"
              />

              <a
                href="#"
                target="_blank"
                class="ui-link"
              >
                lc247_india
              </a>
            </div>
          </div>
          <div
            class="d-hotline h-btn animated zoomIn faster eager-load    "
            onClick={() => setChatToogle(true)}
          >
            <img
              class="custom-icon"
              src={require("../assets/images/skyfiar-bottom.png")}
              alt="Freshchat logo"
            />
            <div
              class="h-btn-notify animated zoomIn  "
              aria-label="2 unread messages"
            >
              <span aria-hidden="true">2</span>
            </div>
          </div>

          {chatToogle && <Chat />}
          {displayPopUp && !localStorage.getItem("seenPopUp") && (
          <div
            id="ember165"
            class="d_preview preview-container appear ember-view"
          >
            <div class="preview-wrapper " id="bubble-preview-wrapper">
              <div class="close-campaign scroll-shake-avoid">
              <span
                  class="icon-ic_close"
                  role="button"
                  tabindex="0"
                  aria-label="Close Notifications"
                  data-ember-action=""
                  data-ember-action-166="166"
                onClick={closePopUp}>x</span>
              </div>
            
                <div class="scroll-shake-avoid">
                  <div class="section campaign-header">
                    <img
                      
                      src="assets/images/popimg.jpg"
                      alt="Attached image"
                      tabindex="0"
                      data-ember-action=""
                      data-ember-action-167="167"
                      style={{width:`100%`}}
                    />
                  </div>
                  <div
                    class="section campaign-section top-border campaign-text-exceeding"
                    role="button"
                    tabindex="0"
                    data-ember-action=""
                    data-ember-action-168="168"
                  >
                    <div class="profile-pic">
                      <img
                        src="assets/images/v.svg"
                        alt="User profile picture"
                        
                      />
                      <span class="agent-name">VIRAT</span>
                    </div>
                    <div class="content">
                      <div id="ember169" class="ember-view">
                        {" "}
                        <div class="h-comment    ">
                          <div
                            id="ember170"
                            class="fc-ui-unity-message-bubble ember-view"
                          >
                            {" "}
                            <div class="h-message-text ">
                              <b>
                                🏏 Cricket Lovers, This One’s for You!
                                <br />
                                Get ready to score big with SKY365 – the
                                ultimate cricket betting experience!
                              </b>
                              <br />
                              🔥 Daily Cashback up to ₹3,650!
                              <br />
                              Why just watch the game when you can win big too?
                              <br />
                              👉 Bet now and enjoy massive cashback every day.
                              <br />
                              💸 More bets, more savings. It's that simple.
                              <br />
                              🔗{" "}
                              <b>
                                Join{" "}
                                <a
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  href="https://www.sky365.com/a"
                                >
                                  SKY365
                                </a>{" "}
                                today and make every match count!
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              

              <div class="scroll-shake-avoid">
                <div class="replay-section h-reply-wrapper"></div>
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>
  );
}

export default LoginMobile;
